/**
 * @generated SignedSource<<b62cb4adcdc7d73e9e87425b8a94f8f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BillingStatus = "billed" | "unbilled" | "%future added value";
export type Currency = "BRL" | "USD" | "%future added value";
export type ProjectStatus = "archived" | "completed" | "in_progress" | "%future added value";
export type DashboardPageQuery$variables = {
  endDate?: string | null | undefined;
  projectId?: string | null | undefined;
  startDate?: string | null | undefined;
};
export type DashboardPageQuery$data = {
  readonly projects: ReadonlyArray<{
    readonly budget: number | null | undefined;
    readonly currency: Currency;
    readonly hourlyRate: number;
    readonly id: string;
    readonly name: string;
    readonly status: ProjectStatus;
  }>;
  readonly tasks: ReadonlyArray<{
    readonly billingStatus: BillingStatus;
    readonly currency: Currency;
    readonly date: string;
    readonly durationMinutes: number;
    readonly hourlyRate: number;
    readonly id: string;
    readonly members: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly project: {
      readonly color: string | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly title: string;
    readonly totalAmount: number;
  }>;
};
export type DashboardPageQuery = {
  response: DashboardPageQuery$data;
  variables: DashboardPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hourlyRate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "projects",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "budget",
        "storageKey": null
      },
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      },
      {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "tasks",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMinutes",
        "storageKey": null
      },
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardPageQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DashboardPageQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "ee26d9098ee32661581537f5a6910fb9",
    "id": null,
    "metadata": {},
    "name": "DashboardPageQuery",
    "operationKind": "query",
    "text": "query DashboardPageQuery(\n  $projectId: ID\n  $startDate: String\n  $endDate: String\n) {\n  projects {\n    id\n    name\n    status\n    budget\n    hourlyRate\n    currency\n  }\n  tasks(projectId: $projectId, startDate: $startDate, endDate: $endDate) {\n    id\n    title\n    date\n    durationMinutes\n    hourlyRate\n    currency\n    totalAmount\n    billingStatus\n    members {\n      id\n      name\n    }\n    project {\n      id\n      name\n      color\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b232ce5658b6ec4c5ba6e737e1cb77c";

export default node;
